import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin, Clock } from "@phosphor-icons/react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/seoData";
import { PaymentMethods } from "@/components/PaymentMethods";
import { TOP_SERVICES, FEATURED_AREAS } from "@/siteContent";

const COMPANY = [
  ["/junk-removal-cost", "Prices"], ["/about", "How It Works"], ["/our-work", "Our Work"], ["/reviews", "Reviews"],
  ["/faq", "FAQ"], ["/blog", "Guides"], ["/pricing-and-disposal-guide", "Dump Fees"], ["/book", "Book Online"],
  ["/contact", "Contact"], ["/review", "Leave a Review"],
];

const Col = ({ title, links }) => (
  <div>
    <h2 className="font-display font-bold uppercase tracking-widest text-sm text-[#5DB82F] mb-4">{title}</h2>
    <ul className="space-y-2.5 text-white/80 text-sm">
      {links.map(([to, label]) => (
        <li key={to}><Link to={to} data-testid={`footer-link-${to.replace(/[^a-z0-9]+/gi, "-").replace(/^-|-$/g, "")}`} className="hover:text-[#5DB82F] transition-colors">{label}</Link></li>
      ))}
    </ul>
  </div>
);

export default function Footer() {
  return (
    <footer className="bg-[#0B1E45] text-white px-5 lg:px-8 pt-16 pb-28 md:pb-16">
      <div className="max-w-7xl mx-auto grid sm:grid-cols-2 md:grid-cols-4 gap-10">
        <div>
          <div className="font-display font-black text-2xl tracking-tighter text-white mb-4">
            CleanOut<span className="text-[#5DB82F]">247</span>
          </div>
          <p className="text-white/60 leading-relaxed text-sm max-w-xs">CleanOut247, LLC — junk removal and hauling serving all of San Diego County.</p>
          <ul className="space-y-3 text-white/90 mt-5">
            <li><a href={`tel:${PHONE_TEL}`} data-testid="footer-phone" className="flex items-center gap-2 hover:text-[#5DB82F] transition-colors"><Phone size={18} weight="fill" /> Call/Text {PHONE_DISPLAY}</a></li>
            <li><a href="mailto:office@cleanout247.com" data-testid="footer-email" className="flex items-center gap-2 hover:text-[#5DB82F] transition-colors"><EnvelopeSimple size={18} weight="fill" /> office@cleanout247.com</a></li>
            <li className="flex items-start gap-2 text-white/70"><MapPin size={18} weight="fill" className="mt-0.5 shrink-0" /> 10335 Reserve Dr, San Diego, CA 92127</li>
            <li className="flex items-center gap-2 text-white/70"><Clock size={18} weight="fill" /> Open 24/7 · Same-day service</li>
          </ul>
        </div>
        <Col title="Services" links={TOP_SERVICES.map((s) => [`/services/${s.slug}`, s.name])} />
        <Col title="Service Areas" links={[...FEATURED_AREAS.slice(0, 7).map((a) => [`/junk-removal/${a.slug}`, a.name]), ["/service-areas", "All service areas"]]} />
        <Col title="Company" links={COMPANY} />
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-white/10">
        <PaymentMethods />
      </div>
      <div className="max-w-7xl mx-auto mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-sm text-white/50">
        <p>© {new Date().getFullYear()} CleanOut247, LLC. All rights reserved.</p>
        <p>Licensed &amp; Insured · San Diego, CA</p>
      </div>
    </footer>
  );
}
